// @flow
import React from 'react';
import {withRouter} from 'react-router';
import AuthorArchive from 'app/components/AuthorArchive';
import {MainLayout as Layout} from 'app/layouts/MainLayout';

class Author extends React.Component<Props> {
	render() {
		return (
			<Layout>
				<AuthorArchive
					authorSlug={this.props.match.params.author}
					page={this.props.match.params.page}
				/>
			</Layout>
		);
	}
}

const Component = withRouter(Author);
export {Component as Author}

export default Component;